// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueMoment from 'vue-moment'
import 'es6-promise/auto'

import VueSweetAlert from 'vue-sweetalert'
Vue.use(VueSweetAlert)

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

import vueSeo from '@deveodk/vue-seo'
Vue.use(vueSeo)

Vue.use(VueMoment)
require('moment/locale/da')

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js